import { useLocation } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import RegistrationForm from "../components/RegistrationForm";
import SEO from "../components/SEO";
import { parseDemoPrefill } from "../lib/timeConverter";

export default function Register() {
    const { search } = useLocation();
    const prefill = parseDemoPrefill(search);
    return (
        <div data-testid="register-page">
            <SEO
                title="Book a Free Demo Class — Anand Tutorials"
                description="Get a free 1:1 demo class with a verified home or online tutor from Anand Tutorials. No payment, no commitment. Tutor matched within 24 hours."
                keywords="free demo tuition, book demo class, free home tutor demo, free online tutor demo"
                path="/register"
            />
            <PageHeader
                eyebrow="Free Demo Class"
                title="Book a 1:1 free demo with a verified tutor."
                subtitle="No payment, no commitment. Tell us about your child and we'll match the perfect tutor in under 24 hours."
            />
            <section className="py-16 bg-white">
                <div className="max-w-2xl mx-auto px-6">
                    <RegistrationForm demoPrefill={prefill} />
                </div>
            </section>
        </div>
    );
}
